import BaseService from '@/services/base.service';
import { getConfigSetup, getStateStore, isStrEmpty } from '@/utils/utils';
import { BetRequest, BetEntry } from '@/types/daily-lotto';
import { BODY_RETAIL, EXTERNAL_ID_TYPE } from '@/constants/lotto';

const configSetup = getConfigSetup();
const state = getStateStore();

class LotoService extends BaseService {
    async getListGames(typeGame: string) {
        const resp = await this.post(`${configSetup.apiGame}/api/${typeGame ? typeGame : 'multi-lotto'}/games`, {
            account: configSetup.account,
            currency: configSetup.currency,
        });

        return resp.data;
    }

    async getListDraw() {
        const resp = await this.post(`${configSetup.apiGame}/api/multi-lotto/draws`, { account: configSetup.account });

        return resp.data;
    }
    async transactLotto(param: any) {
        const { data, isRebet } = param;

        let entries = data;
        entries = entries.map((element: any) => {
            const eventIds = isRebet ? element.event_id : element.events_selected.map((event: any) => event.event_id);

            const item = {
                draws: 1,
                selection: isRebet ? element.selection : [element.selection],
                wager: element.price,
                event_id: eventIds,
                game: element.slug,
            };
            return item;
        });

        const payload = {
            account: configSetup.account,
            additionalInformation: {
                admin_user_id: state.userInfo?.details?.id || '',
            },
            currency: configSetup.currency,
            retail: BODY_RETAIL,
            customerID: state.userInfo.gamev3.lotto_retail_user,
            client_token: state.userInfo.gamev3.token,
            external_id_type: EXTERNAL_ID_TYPE,
            bets: [
                {
                    entries,
                },
            ],
        };

        const resp = await this.postAuth2(`${configSetup.apiGame}/api/multi-lotto/transact`, payload);
        return resp.data;
    }

    async deviceBindingcheck() {
        const urlCms = state.config.setup.apiUrl;

        const resp = await this.post(`${urlCms}/api/retail/cashier/device-binding-check`, '');
        return resp.data;
    }

    // lotto
    transactBetLotto = (entries: any, typeGame: string) => {
        const payload = {
            account: configSetup.account,
            additionalInformation: {
                admin_user_id: state.userInfo?.details?.id || '',
            },
            currency: configSetup.currency,
            retail: BODY_RETAIL,
            customerID: state.userInfo.gamev3.lotto_retail_user,
            client_token: state.userInfo.gamev3.token,
            external_id_type: EXTERNAL_ID_TYPE,
            bets: [
                {
                    entries: entries,
                },
            ],
        };

        return this.postAuth2(
            `${configSetup.apiGame}/api/${typeGame ? typeGame : 'multi-lotto'}/transact`,
            payload,
        ).then(({ data }) => data);
    };

    // daily lotto
    async getDailyGames() {
        const resp = await this.post(`${configSetup.apiGame}/api/v2/fixed-daily-lotto/games`, {
            account: configSetup.account,
            currency: configSetup.currency,
        });
        return resp.data;
    }

    async getDailyDraws() {
        const resp = await this.post(`${configSetup.apiGame}/api/v2/fixed-daily-lotto/draws`, {
            account: configSetup.account,
        });
        return resp.data;
    }

    async callAllGame() {
        const requestGames = this.getDailyGames();
        const requestDraws = this.getDailyDraws();

        return this.all([requestGames, requestDraws])
            .then(
                this.spread((responseGames, responseDraws) => {
                    return {
                        responseGames,
                        responseDraws,
                    };
                }),
            )
            .catch((errors) => {
                console.error('Errors:', errors);
            });
    }

    async getTokenDaily() {
        const payload = {
            account: configSetup.account,
            currency: configSetup.currency,
            customerID: state.userInfo.gamev3.lotto_retail_user,
        };
        const resp = await this.postAuth2(`${configSetup.apiGame}/api/token`, payload, {
            headers: {
                Authorization: configSetup?.tokenV3 || '',
            },
        });
        return resp.data;
    }

    async transactDaily(bets: BetEntry[], token: string, phoneNumber?: string) {
        const payload: BetRequest = {
            additionalInformation: {
                admin_user_id: state.userInfo?.details?.id || '',
            },
            account: configSetup.account,
            currency: configSetup.currency,
            customerID: state.userInfo.gamev3.lotto_retail_user,
            client_token: token,
            bets,
        };

        if (!isStrEmpty(phoneNumber || '')) {
            payload.additionalInformation['phone_number'] = phoneNumber;
        }

        const resp = await this.postAuth2(`${configSetup.apiGame}/api/v2/fixed-daily-lotto/transact`, payload, {
            headers: {
                Authorization: token,
            },
        });
        return resp.data;
    }
}

export default new LotoService();
